var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2862 30.621C32.8541 30.621 15.6778 15.8105 15.6778 15.8105C15.6778 15.8105 32.5341 1 46.2862 1C54.4665 1 61.0967 7.63017 61.0967 15.8105C61.0967 23.9898 54.4665 30.621 46.2862 30.621Z",
    fill: "#FFCD1E",
    stroke: "#030304",
    strokeWidth: 1.7647,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3747 15.8104C39.3747 19.0823 42.0271 21.7346 45.2989 21.7346C48.5708 21.7346 51.2231 19.0823 51.2231 15.8104C51.2231 12.5386 48.5708 9.88623 45.2989 9.88623C42.0271 9.88623 39.3747 12.5386 39.3747 15.8104Z",
    fill: "#88087B",
    stroke: "#030304",
    strokeWidth: 1.7647,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0001 47.1895C1.0001 33.7574 15.8106 16.5811 15.8106 16.5811C15.8106 16.5811 30.6211 33.4375 30.6211 47.1895C30.6211 55.3698 23.9909 62 15.8106 62C7.63126 62 1.0001 55.3698 1.0001 47.1895Z",
    fill: "#88087B",
    stroke: "#030304",
    strokeWidth: 1.7647,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8107 40.2781C12.5388 40.2781 9.88647 42.9304 9.88647 46.2023C9.88647 49.4741 12.5388 52.1265 15.8107 52.1265C19.0825 52.1265 21.7349 49.4741 21.7349 46.2023C21.7349 42.9304 19.0825 40.2781 15.8107 40.2781Z",
    fill: "#FFCD1E",
    stroke: "#030304",
    strokeWidth: 1.7647,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuIcon);
export default __webpack_public_path__ + "static/media/pu-icon.240266c19c77ab882ca46679380cd608.svg";
export { ForwardRef as ReactComponent };